<template>
  <div :class="geistFontClasses" class="app-wrapper">
    <div class="bg-noise"></div>
    <div class="ambient-glow glow-1"></div>
    <div class="ambient-glow glow-2"></div>

    <HeaderComponent />

    <main>
      <RouterView />
    </main>

    <FooterComponent />
  </div>
</template>

<script>
import { RouterView } from 'vue-router';
import HeaderComponent from './components/HeaderComponent.vue';
import FooterComponent from './components/FooterComponent.vue';
import '@/assets/theme/styles.css';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    RouterView,
  },
  // Methods and Mounted hooks for reveal animations have been removed
};
</script>

<style>
/* --- 1. Global Polish --- */
html {
  scroll-behavior: smooth;
  background-color: #f2eee0;
}

.app-wrapper {
  position: relative;
  overflow-x: hidden;
  min-height: 100vh;
}

/* --- 2. Selection Styling --- */
::selection {
  background: #f5e5b0;
  color: #1a1a1a;
}

/* --- 3. Noise & Glows --- */
.bg-noise {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://www.transparenttextures.com/patterns/stardust.png');
  opacity: 0.05;
  pointer-events: none;
  z-index: 9999;
  mix-blend-mode: overlay;
}

.ambient-glow {
  position: fixed;
  width: 70vw;
  height: 70vw;
  border-radius: 50%;
  filter: blur(100px);
  z-index: -1;
  pointer-events: none;
  opacity: 0.5;
}

.glow-1 {
  background: radial-gradient(circle, #faefca 0%, transparent 70%);
  top: -20%;
  left: -20%;
  animation: float 25s infinite alternate ease-in-out;
}

.glow-2 {
  background: radial-gradient(circle, #f5e5b0 0%, transparent 70%);
  bottom: -20%;
  right: -20%;
  animation: float 30s infinite alternate-reverse ease-in-out;
}

@keyframes float {
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(5%, 5%) scale(1.05);
  }
  100% {
    transform: translate(-2%, 8%) scale(0.95);
  }
}

/* --- 4. Typography Fixes --- */
h1,
h2,
h3 {
  letter-spacing: -0.03em;
  font-weight: 800;
}

/* NOTE: Scroll Reveal CSS classes (.reveal, .reveal.active) 
   have been removed to prevent "invisible content" issues on reload.
*/
</style>
